// MIDAS V3 — which Variant E status-table card is the PLC messages card
// (bot request PLC-MESSAGES-CARD-COUNTER-1, MACHINEID_TODO.md 2026-10-31;
// card shape from the bot FYI ALARM-TABLE-UNIFIED-FORM-1, 2026-10-21).
//
// On that card a ✕ row is a message family with at least one set bit, so the
// header bar counts it as "N active", not the generic "N missing"
// (StatusTableV3 → StatusSummaryV3). Same count; every other card keeps its
// words.
//
// WHAT IS MATCHED: the header title over the condition column
// (StatusTableInfo.title = header cell 2, statusTableGrammar.ts), against the
// five titles the bot sends or has sent: `PLC messages` / `Hlásenia PLC` /
// `Hlášení PLC` (since 2026-10-30) and `PLC alarms` / `Alarmy PLC` (before,
// so stored answers match too). Exact match after Unicode NFC, invisible
// characters dropped, whitespace runs collapsed, trimmed, case-folded.
// Anything else (another title, extra words, a chip in the title) is NOT the
// PLC messages card.
//
// This is a literal-wording match — master §21.2 inventory candidate. A
// dedicated bot marker would retire it (§21.1).
//
// Non-ASCII letters are \u-escaped: raw characters in a literal survive
// bundling unescaped and break when a page decodes the script as non-UTF-8.
//
// Pure — no React, no DOM.

const PLC_MESSAGES_CARD_TITLES: ReadonlySet<string> = new Set([
  "plc messages", // en
  "hl\u00E1senia plc", // sk "Hlásenia PLC"
  "hl\u00E1\u0161en\u00ED plc", // cs "Hlášení PLC"
  "plc alarms", // en, before 2026-10-30
  "alarmy plc", // sk / cs, before 2026-10-30
]);

// VS15/VS16, ZWSP..ZWJ, WORD JOINER (same set as statusTableGrammar's marks).
const INVISIBLES_RE = /[\uFE0E\uFE0F\u200B-\u200D\u2060]/g;

const normalizeTitle = (raw: string): string =>
  (raw || "")
    .normalize("NFC")
    .replace(INVISIBLES_RE, "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();

/** True when a status-table title names the PLC messages card. */
export const isPlcMessagesCardTitle = (title: string): boolean =>
  PLC_MESSAGES_CARD_TITLES.has(normalizeTitle(title));
